<topup-attention></topup-attention>
<div class="ni-bell">
    <button id="ni-bell-button" class="ni-bell-button" type="button" (click)="togglePanel()">
        <i class="ki-outline ki-notification-on ni-bell-icon"></i>
        <span class="ni-badge" *ngIf="unreadCount > 0">{{ unreadCount > 99 ? '99+' : unreadCount }}</span>
    </button>

    <dx-popover
        target="#ni-bell-button"
        position="bottom"
        [width]="380"
        [(visible)]="panelVisible"
        [hideOnOutsideClick]="true">
        <div *dxTemplate="let data of 'content'">
            <div class="ni-panel">
                <div class="ni-panel-head">
                    <span class="ni-panel-title">{{ 'notificationInbox.title' | transloco }}</span>
                    <span class="ni-live" [class.connected]="realtimeState === 'connected'">{{ realtimeState === 'connected' ? ('notificationInbox.realtime' | transloco) : ('notificationInbox.polling' | transloco) }}</span>
                    <a class="ni-mark-all" (click)="markAllRead()">{{ 'notificationInbox.mark-all-read' | transloco }}</a>
                </div>
                <div class="ni-list" *ngIf="items.length; else empty">
                    <div class="ni-item" *ngFor="let item of items" [class.ni-item-unread]="!item.IsRead">
                        <span class="ni-severity" [ngClass]="item.SeverityStyle">{{ severityLabel(item) }}</span>
                        <div class="ni-item-body">
                            <div class="ni-item-title">{{ item.Title }}</div>
                            <!-- Nội dung khi có; nếu không, ít nhất cho biết thông báo nói về bản ghi nào. -->
                            <div class="ni-item-content">{{ (item | notificationContent) || (item | notificationSubject) }}</div>
                            <div class="ni-item-time">{{ item.CreatedAt | date:'dd/MM/yyyy HH:mm' }}</div>
                            @if (navigation.target(item); as target) {
                                <dx-button stylingMode="text" [text]="target.label | transloco" (onClick)="open(item)"></dx-button>
                            } @else {
                                <span class="text-xs text-muted-foreground">{{ 'notificationInbox.navigation-unavailable' | transloco }}</span>
                            }
                        </div>
                        <span class="ni-dot" *ngIf="!item.IsRead"></span>
                    </div>
                </div>
                <ng-template #empty>
                    <div class="ni-empty">
                        {{ (loadFailed ? 'notificationInbox.load-error' : 'notificationInbox.empty') | transloco }}
                    </div>
                </ng-template>
                <dx-button class="w-full mt-2" stylingMode="text" [text]="'notificationInbox.view-all' | transloco" (onClick)="viewAll()"></dx-button>
            </div>
        </div>
    </dx-popover>
</div>
